import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ShortLanguageKey} from '@app/shared/util/language-helper';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {

	constructor(@Inject(LOCALE_ID) public locale: string) {
	}

	get currentLanguage(): ShortLanguageKey {
		return this.locale.substring(0, 2).toLowerCase() as ShortLanguageKey;
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const clonedRequest = request.clone({
			headers: request.headers.set('Accept-Language', this.currentLanguage)
		});
		return next.handle(clonedRequest);
	}
}
